/** Tiny classnames joiner — avoids pulling in `clsx` as an extra runtime dependency. */
export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(" ");
}
